import { CommunicationChannelKind } from "@/types/messaging-channel-config";

export type MessageDeliveryDirection = "INBOUND" | "OUTBOUND";

export type MessageDeliveryStatus =
  | "QUEUED"
  | "SENT"
  | "DELIVERED"
  | "READ"
  | "FAILED"
  | "REJECTED";

export interface MessageDelivery {
  id: string;
  hotelId: string;
  bookingId: string | null;
  guestId: string | null;
  streamChannelId: string | null;
  streamMessageId: string | null;
  channel: CommunicationChannelKind;
  direction: MessageDeliveryDirection;
  status: MessageDeliveryStatus;
  providerMessageId: string | null;
  recipientAddress: string | null;
  bodyPreview: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  retryCount: number;
  queuedAt: string;
  sentAt: string | null;
  deliveredAt: string | null;
  readAt: string | null;
  failedAt: string | null;
}

export interface MessageDeliveryFilters {
  bookingId?: string;
  channel?: CommunicationChannelKind;
  direction?: MessageDeliveryDirection;
  status?: MessageDeliveryStatus;
  from?: string;
  to?: string;
  recipientAddressFragment?: string;
}

export interface ListMessageDeliveriesParams extends MessageDeliveryFilters {
  limit?: number;
  cursor?: string;
}

export const MESSAGE_DELIVERY_DIRECTIONS: readonly MessageDeliveryDirection[] =
  ["INBOUND", "OUTBOUND"] as const;

export const MESSAGE_DELIVERY_STATUSES: readonly MessageDeliveryStatus[] = [
  "QUEUED",
  "SENT",
  "DELIVERED",
  "READ",
  "FAILED",
  "REJECTED",
] as const;

export const MESSAGE_DELIVERIES_PAGE_SIZE = 50;
